/* グローバルナビ開閉（1199px以下のハンバーガー時） */
(function () {
  "use strict";

  /* ---- スクロールしたらヘッダーに影を出す ---- */
  var header = document.querySelector(".fsj-site-header");
  if (header) {
    var stuck = false;
    var onScroll = function () {
      var now = (window.pageYOffset || document.documentElement.scrollTop) > 4;
      if (now === stuck) return; /* 変化した時だけ触る＝毎フレームの再描画を避ける */
      stuck = now;
      header.classList.toggle("is-stuck", now);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll(); /* 再読み込みで途中から始まった場合に備えて初回も見る */
  }

  var toggle = document.querySelector(".fsj-navtoggle");
  var nav = document.getElementById("fsj-globalnav");
  if (!toggle || !nav) return;

  function setState(open) {
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    toggle.setAttribute("aria-label", open ? "メニューを閉じる" : "メニューを開く");
    nav.classList.toggle("is-open", open);
    document.body.classList.toggle("fsj-navopen", open);
  }

  toggle.addEventListener("click", function () {
    setState(toggle.getAttribute("aria-expanded") !== "true");
  });

  /* メニュー内のリンクを押したら閉じる */
  nav.addEventListener("click", function (e) {
    if (e.target.closest("a")) setState(false);
  });

  /* Escキーで閉じる */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && toggle.getAttribute("aria-expanded") === "true") {
      setState(false);
      toggle.focus();
    }
  });

  var mq = window.matchMedia("(min-width: 1200px)");
  function onChange(e) {
    if (e.matches) setState(false);
  }
  if (mq.addEventListener) mq.addEventListener("change", onChange);
  else if (mq.addListener) mq.addListener(onChange);
})();

/* ナビ内の開閉（Company） */
(function () {
  "use strict";

  var group = document.querySelector(".fsj-globalnav__grouptoggle");
  if (!group) return;

  var desktop = window.matchMedia("(min-width: 1200px)");

  function close() {
    group.setAttribute("aria-expanded", "false");
  }

  group.addEventListener("click", function () {
    /* ハンバーガー内では常に開いた状態なので、開閉しない */
    if (!desktop.matches) return;
    var open = group.getAttribute("aria-expanded") === "true";
    group.setAttribute("aria-expanded", open ? "false" : "true");
  });

  /* 外側をクリックしたら閉じる */
  document.addEventListener("click", function (e) {
    if (!desktop.matches) return;
    if (e.target.closest(".fsj-globalnav__group")) return;
    close();
  });

  /* Escキーで閉じる。フォーカスは開閉ボタンへ戻す */
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (group.getAttribute("aria-expanded") !== "true") return;
    close();
    group.focus();
  });

  /* 幅が変わったら開いたままにしない */
  function onChange() {
    close();
  }
  if (desktop.addEventListener) desktop.addEventListener("change", onChange);
  else if (desktop.addListener) desktop.addListener(onChange);
})();
